// Lenguaje llano en todo lo que ve el cliente (tabla de palabras del punto 0).
const cap = (orig, rep) => (orig[0] === orig[0].toUpperCase() ? rep[0].toUpperCase() + rep.slice(1) : rep);

export function llano(s, { usted = false, fuente = false } = {}) {
  const pones = usted ? 'lo que pone usted' : 'lo que pones tú';
  const pagarte = usted ? 'no pagarle' : 'no pagarte';
  let t = String(s == null ? '' : s)
    .replace(/Tomador y beneficiario:\s*(<b>[^<]*<\/b>)\s*·\s*asegurado:\s*(<b>[^<]*<\/b>)/g, 'Quién paga y quién recibe la plata: $1 · a quién cubre: $2')
    .replace(/\btomador\b/gi, (m) => cap(m, 'quién paga'))
    .replace(/Responsabilidad civil extracontractual\s*\(RCE\)/gi, (m) => cap(m, usted ? 'daños que le cause a otros' : 'daños que le causes a otros'))
    .replace(/\bRCE\b/g, usted ? 'daños que le cause a otros' : 'daños que le causes a otros')
    .replace(/\bsiniestros\b/gi, (m) => cap(m, 'choques o robos'))
    .replace(/\bsiniestro\b/gi, (m) => cap(m, 'choque o robo'))
    .replace(/\b(del|al)\s+deducible\b/gi, (m, p) => `${p === 'del' || p === 'Del' ? 'de' : 'a'} ${pones}`)
    .replace(/\b(el|un)\s+deducible\b/gi, (m) => cap(m, pones))
    .replace(/\bdeducibles?\b/gi, (m) => cap(m, pones))
    .replace(/\b1 SMMLV\b/g, '$1.750.000')
    .replace(/SMMLV\s*≈\s*/g, 'salario mínimo: ')
    .replace(/\bSMMLV\b/g, 'salario mínimo')
    .replace(/objetar el reclamo/gi, pagarte)
    .replace(/\bobjetar\b/gi, 'negar el pago')
    .replace(/\bauditor[ií]a\b/gi, (m) => cap(m, usted ? 'lo que ya paga' : 'lo que ya pagas'))
    .replace(/\bcompuerta legal\b/gi, (m) => cap(m, 'antes de seguir'))
    .replace(/\bsalvamento\b/gi, 'carro reconstruido');
  if (!fuente) t = t.replace(/\s*\(?CE 006\/2025\)?/g, '');
  return t;
}
